'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');let

VirtualRepeatShadowDirective=class VirtualRepeatShadowDirective extends BaseDirective{
get restrict(){
return'A';
}

link($scope,$element,$attrs){
const scrollerElement=angular.element($element).find('.md-virtual-repeat-scroller');

if(!$attrs.scrollerShadowElement){
throw new Error(`[VirtualRepeatShadowDirective] Attribute "scroller-shadow-element" not defined on directive element.`);
}

const shadowElement=angular.element($attrs.scrollerShadowElement);

if(!_.exists(shadowElement)||shadowElement.length===0){
throw new Error(`[VirtualRepeatShadowDirective] Element described by "scroller-shadow-element" cannot be found.`);
}

let isAtTop=!0;

const onScrollHandler=scrollTop=>{
let wasAtTop=isAtTop;
isAtTop=scrollTop===0;

if(wasAtTop==isAtTop){
return;
}

if(isAtTop){
shadowElement.removeClass('scroller-shadow');
}else{
shadowElement.addClass('scroller-shadow');
}
};

$scope.$evalAsync(()=>{
scrollerElement.scroll(()=>{
fastdom.measure(()=>{
let scrollTop=scrollerElement.scrollTop();
$scope.$apply(()=>{
onScrollHandler(scrollTop);
});
});
});
});
}};


module.exports=VirtualRepeatShadowDirective;
//# sourceMappingURL=virtualRepeatShadowDirective.js.map
